import axios from 'axios'

export default axios.create({
  baseURL: window.tx_ktgdealersearch.api_base,
  headers: {
    common: {
      'X-LOCALE': window.locale.replace('-', '_').split('_')[0]
    }
  }
})
